var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVantagePointIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.0938 24.1694L28.1567 54.8109L55.5861 6.94336H38.0137L28.0938 24.1694Z",
    fill: "#203B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.157 54.8109L28.094 24.1694L18.1584 6.94336H0.585938L28.157 54.8109Z",
    fill: "#00004E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.3477 6.94349H31.827L28.0952 0.44043L24.3477 6.94349Z",
    fill: "#203B63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.827 6.94336H24.3477L28.0952 13.4307L31.827 6.94336Z",
    fill: "#00004E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVantagePointIcon);
export default __webpack_public_path__ + "static/media/vantagePointIcon.1ecfdd679d67dfe12599718fa2680ac0.svg";
export { ForwardRef as ReactComponent };